import { useI18n } from "../i18n";
import type { Countdown } from "../lib/countdown";

export function CountdownBadge({ countdown }: { countdown: Countdown }) {
  const { t } = useI18n();
  const r = 7;
  const c = 2 * Math.PI * r;
  return (
    <span
      className={`countdown${countdown.urgent ? " is-urgent" : ""}`}
      role="timer"
      aria-label={t("pay.expiresAria", { time: countdown.label })}
    >
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
        <circle cx="9" cy="9" r={r} className="countdown-track" />
        <circle
          cx="9"
          cy="9"
          r={r}
          className="countdown-arc"
          strokeDasharray={c}
          strokeDashoffset={c * (1 - countdown.fraction)}
          transform="rotate(-90 9 9)"
        />
      </svg>
      <span className="num" aria-hidden="true">
        {countdown.label}
      </span>
    </span>
  );
}
